import {urlPreguntasFrecuentes} from "../../constants/urls";

export const PREGUNTAS_FRECUENTES_HAS_ERRORED = "PREGUNTAS_FRECUENTES_HAS_ERRORED";
export const PREGUNTAS_FRECUENTES_IS_LOADING = "PREGUNTAS_FRECUENTES_IS_LOADING";
export const SET_PREGUNTAS_FRECUENTES ="SET_PREGUNTAS_FRECUENTES";

export function setPreguntasFrecuentes(payload) {
  return {
    type: SET_PREGUNTAS_FRECUENTES,
    payload
  };
}
const preguntasFrecuentesHasError = () => ({
  type: PREGUNTAS_FRECUENTES_HAS_ERRORED
});

const preguntasFrecuentesIsLoading = () => ({
  type: PREGUNTAS_FRECUENTES_IS_LOADING
});

export const preguntasFrecuentesFetch = () => {
  return async dispatch => {
    dispatch(preguntasFrecuentesIsLoading());
    await fetch(urlPreguntasFrecuentes)
      .then(response => response.json())
      .then(data => {
        const transaccion = data.transaccion;
        if (transaccion) {
          var preguntasFrecuentes = [];
          preguntasFrecuentes = data.preguntas;
          dispatch(setPreguntasFrecuentes(preguntasFrecuentes));
        } else {
          dispatch(preguntasFrecuentesHasError());
        }
      })
      .catch(() => {
        dispatch(preguntasFrecuentesHasError());
      });
  };
};





